import React, { Component } from 'react'
import {
	Box,
	Card,
	TextField,
	Typography,
	Checkbox,
	FormControlLabel,
	Button,
	InputAdornment,
	Snackbar,
	Alert,
	Stack
} from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { DoDisturb } from '@mui/icons-material';
import { ModalSettingMenuPremiumCreate } from './Modals/Setting/ModalSettingMenuPremiumCreate'
import * as SettingMenuPremiumAction from '../actions/SettingMenuPremium'
import { glasConfig } from '../constants/Config';
import { connect } from 'react-redux'
import { NumericFormat } from 'react-number-format';
class SettingMenuPremiumCreate extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			openSnackbar:false,
			isShowPopupCreate:false,
			messageServerError: '',
			errors:{}
		};
		this.resetTogglePopUpMenuPremiumCreate = this.resetTogglePopUpMenuPremiumCreate.bind(this)
		this.submitBtnRef = React.createRef();
	}

	handleCloseSnackbar = () => {
		this.setState({ openSnackbar: false });
	};

	handleSubmit = async (event) => {
		event.preventDefault(); 
		if (this.submitBtnRef.current) {	
			this.submitBtnRef.current.disabled = true;
		}		
		if (this.state.isShowPopupCreate) {
			return; 
		}
		const { dispatch } = this.props
		const { checked, menuName, price, description, deliveryItem } = this.props;
		let errors = {};
		
		if (!menuName.trim()) errors.menuName = 'メニュー名を入力してください';
		if (!description.trim()) errors.description = '説明を入力してください';
		if (checked && !deliveryItem.trim()) errors.deliveryItem = '納品物を記入してください';
		if (!String(price).trim()){
			errors.price = 'メニュー名を入力してください';
		} else if(price < 500 || price > 6000) {
			errors.price = '500〜6,000ptsの間で設定可能';
		}
		if (Object.keys(errors).length) {
			this.setState({ errors });
			if (this.submitBtnRef.current) {
				this.submitBtnRef.current.disabled = false;
			  }
			return { errors }
		  
		}
		// localStorage.removeItem('premiumMenuState');
		let data = {
			application: glasConfig.application,
			title: this.props.menuName,
			description: this.props.description.trim(),
			amount:this.props.price,
			is_deliverable: this.props.checked,
			deliverable_note: this.props.deliveryItem
		}
		try {
			const response = await dispatch(SettingMenuPremiumAction.postMenuPremium(data));
			if (response.code === 0) {
			  this.setState({
				isShowPopupCreate: true,
				openSnackbar: false,
			  });
			  this.props.resetForm();
			} else {
			  this.setState({
				openSnackbar: true,
				messageServerError: response.message
			  });
			  
			}
		  } catch (error) {
			this.setState({
			  openSnackbar: true,
			});
		  }finally {
			if (this.submitBtnRef.current) {
			  this.submitBtnRef.current.disabled = false;
			}	
		}
	}
	resetTogglePopUpMenuPremiumCreate() {
		this.setState({ isShowPopupCreate: false }, () => {
			this.props.dispatch(SettingMenuPremiumAction.getAllMenuPremium());
		});
	}
	render() {
		const { checked, menuName, price, description, deliveryItem  } = this.props;
		const { errors } = this.state;
		const isFormValid =
					menuName.trim() !== '' &&
					String(price).trim() !== '' &&
					description.trim() !== '' &&
					(!checked || (checked && deliveryItem.trim() !== ''));
		return (
			<>
				<ModalSettingMenuPremiumCreate
								isShow={this.state.isShowPopupCreate}
								resetToggle={this.resetTogglePopUpMenuPremiumCreate}
								onClose={this.props.onCancel} 
							/>
				<div className="setting-create-menu-form">
					<div style={{ marginBottom:15 }}>
						<h4 style={{ textAlign: 'center', fontWeight: '700' }} onClick={this.props.onCancel}> 新しいプレミアムメニューを追加する <KeyboardArrowUpIcon /> </h4>
					</div>
				<form onSubmit={this.handleSubmit}>
					<div className='menu-premium-grid-form'>
						<div>
							<label className='color_label'>メニュー名</label>
							<Box sx={{ mb: 2 }}>
								<TextField
									variant="standard"
									fullWidth
									value={menuName}
									onChange={this.props.handleInputChange('menuName', 20)}
									error={!!errors.menuName}
									inputProps={{ maxLength: 20 }}
									helperText={errors.menuName ||									
										<Box  component="span" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
											{menuName.length}/20
										</Box>
									}
								/>
							</Box>
						</div>
						<div>
							<label  className='color_label'>金額</label>
								<Box sx={{ mb: 2 }}>
									<Stack direction="row" alignItems="center" spacing={1}>
										<NumericFormat
											id="price-input"
											customInput={TextField}
											value={price}
											thousandSeparator={true}
											suffix=" pts"
											allowNegative={false}
											variant="standard"
											fullWidth
											decimalScale={0}
											valueIsNumericString={true}
											placeholder=" pts"
											InputProps={{
												endAdornment: (
													<Typography variant="caption" color="error" sx={{ whiteSpace: 'nowrap' }}>
														獲得: {Math.floor((price || 0) * this.props.pointRatio.returning_customer_ratio / 100).toLocaleString()}
													</Typography>
												)
											}}
											helperText={
												errors.price ? (
													<Box component="span" sx={{ color: 'error.main' }}>
													  {errors.price}
													</Box>
												  ) : (
													<Box component="span" sx={{ display: 'flex', justifyContent: 'flex-end', color: 'text.secondary' }}>
													 	500〜6,000ptsの間で設定可能
													</Box>
												  )
											}
											onValueChange={(values) => {
												const { floatValue } = values;
												this.props.handleInputChange('price')({ target: { value: floatValue !== undefined ? floatValue : null } });
											}}
											isAllowed={(values) =>
												values.floatValue === undefined || (values.floatValue >= 0 && values.floatValue <= 6000)
											}
										/>
									</Stack>
								</Box>
						</div>
					</div>
					<div className='menu-premium-grid-form'>
						<div>
							<label  className='color_label'>説明</label>
							<Box sx={{ mb: 2 }}>
								<TextField
									variant="standard"
									placeholder="ここに説明文"
									multiline
									rows={3}
									fullWidth
									value={description}
									onChange={this.props.handleInputChange('description', 140)}
									error={!!errors.description}
									inputProps={{ maxLength: 140, sx: {
										'&::placeholder': {
										  fontSize: '12px'
										},
									  } }}
									helperText={
										errors.description ||
										<Box component="span" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
											{description.length}/140
										</Box>
									}
								/>
							</Box>
						</div>
						<div>
							<Box sx={{ mb: 2 }}>
								<Typography  sx={{ fontWeight: '100' }} className='color_label'>
									納品物
								</Typography>
								<Box >
									<FormControlLabel
										control={
											<Checkbox
												checked={!checked}
												onChange={(e) => this.props.handleCheckboxChange(!e.target.checked)}
											/>
										}
										label="なし"
										componentsProps={{
											typography: {
											  sx: { fontWeight: 400 }
											}
										  }}
									/>
									<FormControlLabel
										control={
											<Checkbox
												checked={checked}
												onChange={(e) => this.props.handleCheckboxChange(e.target.checked)}
											/>
										}
										label="あり"
										componentsProps={{
											typography: {
											  sx: { fontWeight: 400 }
											}
										  }}
									/>
									{checked && <TextField
										fullWidth
										variant="standard"
										size="small"
										placeholder="納品物をお書きください"
										value={deliveryItem}
										inputProps={{ maxLength: 16, sx: {
											'&::placeholder': {
											  fontSize: '12px'
											},
										  } }}
										helperText={
											errors.deliveryItem ||
											<Box component="span" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
												{deliveryItem.length}/16
											</Box>
										}
										error={!!errors.deliveryItem}
										onChange={this.props.handleInputChange('deliveryItem', 16)}
										sx={{ mt: 1 }}
									/>}
									<Typography className='color_label' variant="caption" sx={{ display: 'block', mt: 0.5 }}>
										※メニューの完了を示すことができるものをご提示できる場合「あり」にチェックを入れ記入してください。<br></br>
										例: 実施の様子を写真あるいはテキストに起こしたもの
									</Typography>
								</Box>
							</Box>
						</div>
					</div>
					<Box sx={{ mb: 3, bgcolor: '#f9f9f9', p: 2, borderRadius: 2 }}>
						<Typography variant="h6" color="error" gutterBottom align="center"  style={{fontWeight: 700}}>
							注意事項
						</Typography>
						<Typography variant="body2" component="div">
								
							<p>	このメニュー機能はStella内でのサブコンテンツとなります。占い師の皆さまには、メニューの実施だけでなくユーザー様とのコミュニケーションを大切にしていただきますようお願いいたします。</p>
							<p>また、このメニュー機能で獲得したポイントはランキングイベントやミッションの達成条件には反映されず、占い師のランキングにも影響しません。</p>

							<h5>1. 承認されないメニュー</h5>
							<p>以下のようなメニューは承認されません。</p>
									
							<ul>
								<li>身体に影響を与えるメニュー（例：体調が良くなる、身体が軽くなる）</li>
								<li>モノに対する施術（例：家の環境を整える）</li>
								<li>他人に害を与える内容（例：呪い）</li>
								<li>占いとは無関係な内容、あるいは占い師としての技術を伝える内容（例：◯◯についての鑑定方法を教える）</li>
								<li>グッズの販売や発送を伴うメニュー（例：念を込めたパワーストーンを送る）</li>
								<li>利用規約に反する内容</li>
								<li>その他、Stella運営事務局が不適切だと判断した内容</li>
							</ul>

							<h5>2. 禁止行為</h5>
							<p>以下のような行為は禁止しています。違反した場合、ポイントの没収やアカウント停止となる場合があります。</p>
							<ul>
								<li>
								占い師からユーザー様に対して、メニューの申し込みを促す営業行為を行うこと。
								</li>
								<li>一つのメニューを繰り返し申し込むことを推奨する、あるいは他のメニューも合わせて申し込むように勧めること。</li>
								<li>施術やコンテンツのみを提供し、ユーザー様とのコミュニケーションを行わないこと。</li>
								<li>メニューに記載の金額以上のポイントを請求すること</li>
								<li>利用規約に反する行為</li>
							</ul>
							<h5>3. メニュー提供に関するルール</h5>
							<p>ユーザー様のメニュー申込後、7日以内に占い師から連絡がなかった場合、ユーザー様へのポイント返還（＝占い師からのポイント没収）の対象となる場合があります。</p>
							<p>また、メニュー進行中に占い師との連絡が途絶え、メニューが中断された場合も、ユーザー様へのポイント返還（＝占い師からのポイント没収）の対象となる場合があります。</p>
							<p>メニューの完了を明瞭にするため、「納品物」を「あり」に設定し、メニューの完了時に記載した内容の納品を行うことを推奨します。</p>

							<h5>4. 免責事項</h5>
							<p>本コンテンツを通じてユーザー様との間にトラブルが発生した場合、Stellaはその責任を負いません</p>
						</Typography>
					</Box>

					<Button
					 	ref={this.submitBtnRef}
					 	type="submit"
						variant="contained"
						sx={{ mt: 2 }}
						style={{ color:'#ffffff',  background: isFormValid ? '#11ad9d' : '#bdbdbd', display:'flex', margin:'0 auto 50px', fontWeight: 600}}
						disabled={!isFormValid}
					>
						注意事項に同意し、審査に提出する
					</Button>
				</form>
				</div>
				<hr className='inline'></hr>
				<div className="primary-title1-menu-premium">
					<p>メニューの修正・削除・並び替えができます。</p>
					<p>修正時は再審査が行われます。</p>
				</div>
				<hr className='inline'></hr>
				<Snackbar
					open={this.state.openSnackbar}
					autoHideDuration={3000}
					onClose={this.handleCloseSnackbar}
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
				>
					<Alert onClose={this.handleCloseSnackbar} severity="error">
						{this.state.messageServerError}
					</Alert>
				</Snackbar>
			</>
			
		)
	}
}

const mapStateToProps = (store) => {
	return {
		SettingMenuPremium: store.SettingMenuPremium,
	}
}

export default connect(mapStateToProps)(SettingMenuPremiumCreate)

